import React, { useContext } from 'react';
import { VARIANTS as LOGO_VARIANT } from '@prisjakt/ui-store-logo';
import RatingHelper from 'src/components/rating/rating-helper';
import { CountryFlag } from 'src/components/country-flag';
import RatingSmiley from 'src/components/rating/smiley-rating';
import SotyBadgeLink from '../soty-badge-link';
import StoreLink from '../store-link';
import ViewportContext from '../../../../components/viewport/context';

import { Award, Store } from '../../../../types';
import { StoreLinkClickProps } from '../../types';

import { SHOP_LOGO_WIDTH } from '../../constants';

import * as S from './styles';

type OwnProps = {
  store: Store;
  sotyBadge?: Award | null;
  storeLinkClick: (props: StoreLinkClickProps) => void;
};

const Header = ({ store, sotyBadge, storeLinkClick }: OwnProps) => {
  const { isMobile } = useContext(ViewportContext);

  const renderTitleAndLogo = () => (
    <S.TitleAndLogoWrapper>
      {store.featured && (
        <S.StoreLogo
          logoUrl={store.logo}
          name={store.name}
          storeId={store.id}
          featured={store.featured}
          hasImage={Boolean(store.hasLogo)}
          variant={LOGO_VARIANT.HEADING}
          width={store.logo ? SHOP_LOGO_WIDTH : undefined}
        />
      )}
      <S.TitleWrapper>
        <li>
          <S.Title>{store.name}</S.Title>

          {store.userReviewSummary.rating &&
            store.userReviewSummary.count !== 0 && (
              <RatingSmiley
                featured={Boolean(store.featured)}
                rating={RatingHelper.convert(store.userReviewSummary.rating, 1)}
                reviewCount={store.userReviewSummary.countTotal}
                scoreVisibility="row"
                size="small"
              />
            )}
        </li>

        <li>
          <CountryFlag
            countryCode={store.countryCode}
            showTitleAsTooltip={false}
            title={store.countryCode}
          />
          <S.CountryText>{store.countryCode}</S.CountryText>
        </li>

        {store.externalUri && store.featured && (
          <li>
            <StoreLink store={store} storeLinkClick={storeLinkClick} />
          </li>
        )}
      </S.TitleWrapper>
    </S.TitleAndLogoWrapper>
  );

  const renderGeneralInfo = () => {
    return store.featured && store.providedByStore?.generalInformation ? (
      <S.InfoList list={store.providedByStore.generalInformation as string[]} />
    ) : null;
  };

  const renderSotyBadge = () => {
    return sotyBadge?.logo ? (
      <S.SotyBadgeWrapper>
        <SotyBadgeLink sotyBadge={sotyBadge} />
      </S.SotyBadgeWrapper>
    ) : null;
  };

  return (
    <S.Header>
      {isMobile ? (
        <>
          {renderTitleAndLogo()}
          {renderSotyBadge()}
          {renderGeneralInfo()}
        </>
      ) : (
        <>
          <S.StoreInfoWrapper>
            {renderTitleAndLogo()}
            {renderGeneralInfo()}
          </S.StoreInfoWrapper>
          {renderSotyBadge()}
        </>
      )}
    </S.Header>
  );
};

export default Header;
